// UI models for Operation modal (Pickup/Loading/Clearance/Unloading) with In/Out steps

export type PhotoAttachment = {
    // Local File during creation or string URL when loaded from API
    file?: File;
    url?: string;
    name: string;
    sizeBytes?: number;
};

export type OperationItem = {
    name: string;
    quantity: number;
    unit?: string;
    notes?: string;
};

export type OperationStepPayload = {
    dateISO: string; // YYYY-MM-DD
    timeISO: string; // HH:mm or full ISO time
    odoKm?: number;
    items: OperationItem[];
    photos: PhotoAttachment[];
};

export type OperationType = 'pickup' | 'loading' | 'clearance' | 'unloading';

export type OperationStatus =
    | 'idle'
    | 'step_in_recorded'
    | 'step_completed';

export type BookingStatus = 'cancel' | 'hold' | 'completed';

export type TripStatus = 'cancel' | 'hold' | 'completed';

export interface OperationDraft {
    tripId: string | number;
    operationType: OperationType;
    in: OperationStepPayload;
    out: OperationStepPayload;
    status: OperationStatus;
    bookingStatus?: BookingStatus;
    tripStatus?: TripStatus;
}

export interface OperationModalState {
    isOpen: boolean;
    activeStep: 0 | 1; // 0 -> Pickup In, 1 -> Pickup Out
    isSubmitting: boolean;
    validationErrors: Record<string, string>;
    draft: OperationDraft;
}

export type CreateEmptyOperationDraftArgs = {
    tripId: string | number;
    operationType: OperationType;
};

export function createEmptyOperationDraft(args: CreateEmptyOperationDraftArgs): OperationDraft {
    const now = new Date();
    const dateISO = now.toISOString().slice(0, 10);
    const timeISO = now.toISOString();
    const emptyStep: OperationStepPayload = {
        dateISO,
        timeISO,
        odoKm: 0,
        items: [],
        photos: [],
    };
    return {
        tripId: args.tripId,
        operationType: args.operationType,
        in: { ...emptyStep },
        out: { ...emptyStep },
        status: 'idle',
        bookingStatus: undefined,
        tripStatus: undefined,
    };
}


